import { apiClient, USE_MOCK } from "./apiClient";
import mockDb from "./mockDb";

export const BookingService = {
  listBookings: async () => {
    if (USE_MOCK) return mockDb.getBookings();
    const { data } = await apiClient.get("/bookings");
    return data;
  },

  getBooking: async (id) => {
    if (USE_MOCK) return mockDb.getBookingById(id);
    const { data } = await apiClient.get(`/bookings/${id}`);
    return data;
  },

  updateBooking: async (id, payload) => {
    if (USE_MOCK) return mockDb.updateBooking(id, payload);
    const { data } = await apiClient.put(`/bookings/${id}`, payload);
    return data;
  },

  setBookingStatus: async (id, status) => {
    if (USE_MOCK) return mockDb.updateBooking(id, { status });
    const { data } = await apiClient.patch(`/bookings/${id}/status`, { status });
    return data;
  },

  assignBooking: async (id, employeeId, employeeName) => {
    if (USE_MOCK) return mockDb.updateBooking(id, { assignedEmployeeId: employeeId, assignedEmployeeName: employeeName, status: "confirmed" }); // Usually assigning confirms it? Or keeps pending? Let's assume Confirm. User said "Admin can assign...".
    const { data } = await apiClient.post(`/bookings/${id}/assign`, { employeeId });
    return data;
  }
};
